export default __webpack_public_path__ + "static/media/av_logo.3f915401.png";